import Modal from "react-bootstrap/Modal";
import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";
import ListGroup from "react-bootstrap/ListGroup";
import { useTranslation } from "react-i18next";
import { getCoverName } from "../../utils/commonHelper";

export const CompanyDetails = ({ show, companyData, handleClose, isCovers = false }) => {
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n?.language || "en";

  const includedCovers = companyData?.included_covers || [];
  const optionalCovers = companyData?.optional_covers || [];
  const uniqueIncludedCovers = includedCovers?.filter((cover, index, self) => {
    const currentName = getCoverName(companyData, cover);

    return (
      index ===
      self.findIndex(
        (c) => getCoverName(companyData, c) === currentName
      )
    );
  });
  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      size="lg"
      scrollable
      dir={currentLanguage === "ar" ? "rtl" : "ltr"}
    >
      <Modal.Header closeButton>
        <Modal.Title>
          {currentLanguage === "ar"
            ? companyData?.company_name_ar
            : companyData?.company_name}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body className="company-details-modal">
        { !isCovers &&  <div
          className="mb-3"
          dangerouslySetInnerHTML={{
            __html:
              currentLanguage === "ar"
                ? companyData?.company_description_ar
                : companyData?.company_description_en || "<p>Not Found</p>",
          }}
        />
        }
      
        <Tabs defaultActiveKey="included" className="mb-3">

          {isCovers ? <Tab eventKey="included" title={t("includedcovers")}>
            {/* <h6 className="mt-3">{t("includedcovers")}</h6> */}
            <ListGroup variant="flush" className="mb-3">
              {uniqueIncludedCovers.length ? (
                uniqueIncludedCovers.map((cover, idx) => (
                  <ListGroup.Item key={idx}>
                    <i className="bi bi-shield-fill-check text-success me-2"></i>
                    {getCoverName(companyData, cover)}
                  </ListGroup.Item>
                ))
              ) : (
                <ListGroup.Item>{t("noCoverMsg")}</ListGroup.Item>
              )}
            </ListGroup>


            {/* <h6>{t("optionalcovers")}</h6>
            <ListGroup variant="flush">
              {optionalCovers.length ? (
                optionalCovers.map((cover, idx) => (
                  <ListGroup.Item key={idx}>
                    <i className="bi bi-shield text-secondary me-2"></i>
                    {getCoverName(companyData, cover)}
                  </ListGroup.Item>
                ))
              ) : (
                <ListGroup.Item>{t("noCoverMsg")}</ListGroup.Item>
              )}
            </ListGroup> */}
          </Tab> : <Tab eventKey="included" title="FAQs">
            <div
              className="mt-3"
              dangerouslySetInnerHTML={{
                __html:
                  currentLanguage === "ar"
                    ? companyData?.faq_ar
                    : companyData?.company_faq_en || "<p>Not Found</p>",
              }}
            />
          </Tab>
          }


          {(optionalCovers?.length > 0 && isCovers)&&  (
            <Tab eventKey="options" title={t("optionalcovers")}>
              <ListGroup variant="flush">
                {optionalCovers.map((cover, idx) => (
                  <ListGroup.Item key={idx}>
                    <i className="bi bi-shield text-secondary me-2"></i>
                    {getCoverName(companyData, cover)}
                  </ListGroup.Item>
                ))}
              </ListGroup>
            </Tab>
          )}


        </Tabs>
      </Modal.Body>
    </Modal>
  );
};